export { default } from '../en/Imprint';



// WEBPACK FOOTER //
// ./src/components/async/enImprint.js